import { jsxs as v, Fragment as x, jsx as l } from "react/jsx-runtime";
import { useState as H, useContext as J, useEffect as A, Fragment as K } from "react";
import { useTranslation as Q } from "react-i18next";
import { useDndContext as W, DragOverlay as X } from "@dnd-kit/core";
import O from "classnames";
import { ThemeContext as Z, Grid as j, GridItem as u, LoadingIndicator as M } from "@forma/forma-ui-kit";
import b from "../../../helpers/preloadImages.js";
import { templatesIcons as U } from "../../../data/mock.js";
import G from "./ExplorerGridItem/ExplorerGridItem.js";
import S from "./ExplorerGridItem/Placeholder.js";
import $ from "./DragItem/index.js";
import f from "./DropItem/index.js";
const rr = "forma-filling__explorer-grid__grid", nr = "forma-filling__explorer-grid__item", lr = "forma-filling__explorer-grid__draggable", ir = "forma-filling__explorer-grid__group", dr = "forma-filling__explorer-grid__group-5", ar = "forma-filling__explorer-grid__group-4", gr = "forma-filling__explorer-grid__group-3", or = "forma-filling__explorer-grid__group-2", er = "forma-filling__explorer-grid__group-1", pr = "forma-filling__explorer-grid__groupItems", mr = "forma-filling__explorer-grid__dropContainer", _r = "forma-filling__explorer-grid__groupLoader", cr = "forma-filling__explorer-grid__showAll", hr = "forma-filling__explorer-grid__showAllLink", a = {
  grid: rr,
  item: nr,
  draggable: lr,
  group: ir,
  "group-5": "forma-filling__explorer-grid__group-5",
  group5: dr,
  "group-4": "forma-filling__explorer-grid__group-4",
  group4: ar,
  "group-3": "forma-filling__explorer-grid__group-3",
  group3: gr,
  "group-2": "forma-filling__explorer-grid__group-2",
  group2: or,
  "group-1": "forma-filling__explorer-grid__group-1",
  group1: er,
  groupItems: pr,
  dropContainer: mr,
  groupLoader: _r,
  showAll: cr,
  showAllLink: hr
}, B = { tablet: 3, tabletS: 2, phone: 1 }, sr = 60, Or = ({
  folder: r,
  items: e,
  active: g,
  updated: c,
  isLoading: R,
  onToggleMenu: N,
  isModalOpen: k,
  selected: p,
  subitems: h,
  subitemsIsLoading: P,
  editing: t,
  actions: s,
  optionsState: d,
  noItems: I,
  isInGroup: z,
  contextMenu: y
}) => {
  var D;
  let C = !1;
  const _ = e && g && e.find(({ id: n }) => n === g), { t: V } = Q(), [w, Y] = H(0), { viewport: q } = J(Z), E = W(), L = (e == null ? void 0 : e.find(({ id: n }) => {
    var o, m;
    return n === ((m = (o = E.active) == null ? void 0 : o.data.current) == null ? void 0 : m.id);
  })) ?? (h == null ? void 0 : h.find(({ id: n }) => {
    var o, m;
    return n === ((m = (o = E.active) == null ? void 0 : o.data.current) == null ? void 0 : m.id);
  }));
  return A(() => {
    b([
      ...Object.values(U.grid.folders),
      ...Object.values(U.grid.files)
    ]);
  }, []), A(() => {
    const n = document.getElementById("templates_grid");
    if (n) {
      const m = window.getComputedStyle(n).getPropertyValue("grid-template-columns").split(" ").length;
      Y(m);
    }
  }, [q]), A(() => {
    c && setTimeout(() => {
      const n = document.getElementById(`file_explorer_template_${c}`);
      n && window.scrollTo({ top: window.scrollY + n.getBoundingClientRect().top - sr, behavior: "smooth" });
    }, 200);
  }, [c]), /* @__PURE__ */ v(x, { children: [
    /* @__PURE__ */ l(
      f,
      {
        id: (r == null ? void 0 : r.id) ?? null,
        dropId: "root",
        name: "",
        type: "folder",
        className: a.dropContainer,
        children: /* @__PURE__ */ l(j, { columns: 4, className: a.grid, responsive: B, id: "templates_grid", children: R ? [...Array(10)].map((n, o) => /* @__PURE__ */ l(u, { className: a.item, children: /* @__PURE__ */ l(S, {}) }, o)) : e && e.length ? /* @__PURE__ */ l(x, { children: e.map((n, o) => {
          var T;
          const m = (o + 1) % w === 0;
          g === n.id && (C = !0);
          const F = (g === n.id || C) && (m || o + 1 === e.length);
          return F && (C = !1), /* @__PURE__ */ v(K, { children: [
            /* @__PURE__ */ l(u, { className: a.item, children: /* @__PURE__ */ l(
              $,
              {
                id: n.id,
                name: n.name,
                type: n.type,
                removed: n.removed,
                folderId: (r == null ? void 0 : r.id) ?? null,
                isUpdated: c === n.id,
                isMenuOpen: (d == null ? void 0 : d.itemId) === n.id,
                isModalOpen: k,
                isChildsOpen: g === n.id,
                children: /* @__PURE__ */ l(
                  f,
                  {
                    id: n.id,
                    dropId: n.id,
                    name: n.name,
                    type: n.type,
                    className: a.dropContainer,
                    children: /* @__PURE__ */ l(
                      G,
                      {
                        item: n,
                        parent: r != null && r.id && r.name && r.translatedName ? {
                          id: r.id,
                          name: r.name,
                          translatedName: r.translatedName,
                          parentId: (T = r.path) != null && T.length ? r.path[r.path.length - 1].id : null
                        } : void 0,
                        isActive: g === n.id || (d == null ? void 0 : d.moveToItemId) === n.id,
                        isUpdated: c === n.id,
                        isSelected: p == null ? void 0 : p.includes(n.id),
                        isMenuOpen: (d == null ? void 0 : d.itemId) === n.id,
                        onToggleMenu: N,
                        editing: t,
                        actions: s,
                        isInGroup: z,
                        contextMenu: y
                      }
                    )
                  }
                )
              }
            ) }),
            _ && F && /* @__PURE__ */ l(u, { className: O(a.group, a[`group-${w}`]), children: /* @__PURE__ */ l(
              f,
              {
                id: g,
                dropId: "group_" + g,
                name: _.name,
                type: _.type,
                className: a.dropContainer,
                children: P ? /* @__PURE__ */ l("div", { className: a.groupLoader, children: /* @__PURE__ */ l(M, {}) }) : h != null && h.length ? /* @__PURE__ */ v(x, { children: [
                  /* @__PURE__ */ l(j, { columns: 4, responsive: B, className: a.groupItems, children: h.map((i) => /* @__PURE__ */ l(u, { className: a.item, children: /* @__PURE__ */ l(
                    $,
                    {
                      id: i.id,
                      name: i.name,
                      type: i.type,
                      folderId: g,
                      isUpdated: c === i.id,
                      isMenuOpen: (d == null ? void 0 : d.itemId) === i.id,
                      isModalOpen: k,
                      isChildsOpen: g === n.id,
                      children: /* @__PURE__ */ l(
                        f,
                        {
                          id: i.id,
                          dropId: i.id,
                          name: i.name,
                          type: i.type,
                          className: a.dropContainer,
                          children: /* @__PURE__ */ l(
                            G,
                            {
                              item: i,
                              isActive: g === i.id || (d == null ? void 0 : d.moveToItemId) === i.id,
                              isUpdated: c === i.id,
                              isSelected: p == null ? void 0 : p.includes(i.id),
                              isMenuOpen: (d == null ? void 0 : d.itemId) === i.id,
                              parent: {
                                id: _.id,
                                name: _.name,
                                translatedName: _.translatedName,
                                parentId: r == null ? void 0 : r.id
                              },
                              onToggleMenu: N,
                              editing: t,
                              actions: s,
                              contextMenu: y,
                              isInGroup: !0
                            }
                          )
                        }
                      )
                    }
                  ) }, i.id)) }),
                  /* @__PURE__ */ l("div", { className: a.showAll, children: /* @__PURE__ */ l(
                    "button",
                    {
                      onClick: () => {
                        var i;
                        return (i = s.onDoubleClickItem) == null ? void 0 : i.call(s, _);
                      },
                      className: a.showAllLink,
                      children: V("show_all")
                    }
                  ) })
                ] }) : /* @__PURE__ */ l(x, { children: I && I(_.id) })
              }
            ) })
          ] }, n.id);
        }) }) : /* @__PURE__ */ l(u, { className: O(a.group, a[`group-${w}`]), children: I && I(r == null ? void 0 : r.id) }) })
      }
    ),
    /* @__PURE__ */ l(X, { zIndex: 10, children: /* @__PURE__ */ l(u, { className: O(a.item, a.draggable), children: !!(L && e) && /* @__PURE__ */ l(
      G,
      {
        item: L,
        parent: r != null && r.id && r.name && r.translatedName ? {
          id: r.id,
          name: r.name,
          translatedName: r.translatedName,
          parentId: (D = r.path) != null && D.length ? r.path[r.path.length - 1].id : null
        } : void 0,
        isSelected: p == null ? void 0 : p.includes(L.id),
        onToggleMenu: N,
        editing: t,
        actions: s,
        contextMenu: y
      }
    ) }) })
  ] });
};
export {
  Or as default
};
